import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=4455ef22&scoped=true&"
import script from "./IconBox.vue?vue&type=script&lang=ts&"
export * from "./IconBox.vue?vue&type=script&lang=ts&"
import style0 from "./IconBox.vue?vue&type=style&index=0&id=4455ef22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455ef22",
  null
  
)

export default component.exports